define.alias("shared/components/shared/card/container", "settings/components/shared/card/container");